import { createAction } from 'redux-actions';
import { FILE_UPLOAD_SUCCEEDED } from '../constants/actionTypes';
export const fileUploadSucceeded = createAction(FILE_UPLOAD_SUCCEEDED, ({
  fileUpload
}) => ({
  fileUpload
}));